<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form class="search" action="javascript:void(0);" @submit.prevent="handleSubmit(submit)">
        <div class="form-group">
          <div class="input-container">
            <ValidationProvider name="item-no" rules="required" v-slot="{ errors }">
              <label for="item-no">{{ $t('hs.att-dashboard.item-no') }}</label>
              <input id="item-no" name="item-no" :data-vv-as="$t('hs.att-dashboard.item-no')" v-model="articleNo" type="text"/>
              <span v-if="errors[0]">{{ $t('hs.att-dashboard.item-no-required') }}</span>
            </ValidationProvider>
          </div>
          <div class="input-container">
            <ValidationProvider name="serial-no" rules="required" v-slot="{ errors }">
              <label for="serial-no">{{ $t('hs.att-dashboard.serial-no') }}</label>
              <input id="serial-no" name="serial-no" :data-vv-as="$t('hs.att-dashboard.serial-no')" v-model="serialNo" type="text"/>
              <span v-if="errors[0]">{{ $t('hs.att-dashboard.serial-no-required') }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="button-holder">
          <button class="clavis-btn clavis-btn-primary" type="submit" >{{ $t('hs.att-dashboard.search') }}</button>
        </div>
    </form>
  </ValidationObserver>
</template>

<script>
  import { ValidationProvider, ValidationObserver } from 'vee-validate'

  export default {
    name: 'Search',
    components: {
      ValidationProvider,
      ValidationObserver
    },
    data () {
      return {
        articleNo: null,
        serialNo: null
      }
    },
    methods: {
      submitSearch: function () {
        this.$emit('submit-search', {
          articleNo: this.articleNo,
          serialNo: this.serialNo
        })
      },
      submit () {
        this.submitSearch()
      }
    }
  }
</script>

<style lang="scss" scoped>
.search {
  @extend %infinityWideBackground;
  background-color: $background-color;
  padding-top: $component-padding;
  padding-bottom: $component-padding;
  border-top: 2px solid $brand-primary;
  border-bottom: 2px solid $brand-primary;
  margin-bottom: $component-padding;

  .button-holder {
    display: flex;
    justify-content: flex-end;
  }
}

.form-group {
  display: flex;
  flex-direction: column;

  .input-container {
    width: 100%;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}

.input-container {
  display: inline-block;

  span, label {
    display: block;
    color: $brand-primary;
    font-weight: bold;
    padding: 0.5em 0;
  }

  input {
    font-family: "OpenSans", sans-serif;
    background-color: #fff;
    border: 1px solid $input-border-color;
    box-sizing: border-box;
    padding: 0.5em;
    width: 100%;

    &[type='number'] {
      appearance:textfield;
    }

    &::outer-spin-button,
    &::inner-spin-button {
      appearance: none;
    }
  }
}

@media only screen and (min-width: $screen-sm-min) {
  .form-group {
    flex-direction: row;
  }

  .input-container {
    margin: 0 $input-margin;
  }
}
</style>
